import React from "react";

export const TransferHistoryEmptyStateIcon = ({
  width = "360",
  height = "341",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 360 341"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M185.571 303.207C266.517 303.207 332.473 237.525 332.473 156.854C332.2 75.9102 266.517 10.2285 185.571 10.2285C104.352 10.2285 38.6685 75.9102 38.6685 156.582C38.6685 237.525 104.352 303.207 185.571 303.207Z"
        fill="#F3F1FC"
      />
      <path
        d="M348.369 215.187C354.54 215.187 359.543 210.184 359.543 204.013C359.543 197.842 354.54 192.839 348.369 192.839C342.197 192.839 337.194 197.842 337.194 204.013C337.194 210.184 342.197 215.187 348.369 215.187Z"
        fill="#F3F1FC"
      />
      <path
        d="M262.618 15.8598C266.833 15.8598 270.249 12.4433 270.249 8.22873C270.249 4.01421 266.833 0.597656 262.618 0.597656C258.403 0.597656 254.987 4.01421 254.987 8.22873C254.987 12.4433 258.403 15.8598 262.618 15.8598Z"
        fill="#F3F1FC"
      />
      <path
        d="M26.1314 254.968C33.9586 254.968 40.3037 248.623 40.3037 240.796C40.3037 232.969 33.9586 226.624 26.1314 226.624C18.3042 226.624 11.959 232.969 11.959 240.796C11.959 248.623 18.3042 254.968 26.1314 254.968Z"
        fill="#F3F1FC"
      />
      <g filter="url(#filter0_d_7062_86955)">
        <path
          d="M128.882 71.4306C128.882 79.5193 122.34 86.0606 114.181 86.0606C114.04 86.0606 112.844 86.0606 104.052 86.0606C97.9326 86.0606 88.1556 86.0606 72.5405 86.0606H65.0846C55.3076 86.2716 47.5 78.4642 47.5 69.0392C47.5 59.5437 55.3779 51.6661 65.2956 52.1584C73.8066 25.5712 112.774 29.2991 116.08 56.8006C123.395 57.715 128.882 63.9046 128.882 71.4306Z"
          fill="url(#paint0_linear_7062_86955)"
        />
        <path
          d="M65.0846 85.9606L65.0824 85.9606C55.3614 86.1704 47.6 78.4081 47.6 69.0392C47.6 59.5996 55.4313 51.7688 65.2906 52.2583L65.3674 52.2621L65.3908 52.1889C73.8694 25.7028 112.688 29.4189 115.981 56.8126L115.99 56.8902L116.068 56.8998C123.332 57.8079 128.782 63.9546 128.782 71.4306C128.782 79.4637 122.285 85.9606 114.181 85.9606H114.18H114.179H114.178H114.177H114.176H114.175H114.174H114.173H114.172H114.171H114.17H114.169H114.168H114.167H114.166H114.164H114.163H114.162H114.16H114.159H114.158H114.156H114.155H114.153H114.152H114.15H114.149H114.147H114.146H114.144H114.142H114.14H114.139H114.137H114.135H114.133H114.131H114.129H114.127H114.125H114.123H114.121H114.119H114.117H114.115H114.113H114.11H114.108H114.106H114.103H114.101H114.098H114.096H114.093H114.091H114.088H114.086H114.083H114.08H114.077H114.075H114.072H114.069H114.066H114.063H114.06H114.057H114.054H114.05H114.047H114.044H114.041H114.037H114.034H114.03H114.027H114.023H114.02H114.016H114.013H114.009H114.005H114.001H113.997H113.994H113.99H113.986H113.982H113.977H113.973H113.969H113.965H113.96H113.956H113.952H113.947H113.943H113.938H113.934H113.929H113.924H113.919H113.915H113.91H113.905H113.9H113.895H113.89H113.884H113.879H113.874H113.869H113.863H113.858H113.852H113.847H113.841H113.835H113.83H113.824H113.818H113.812H113.806H113.8H113.794H113.788H113.782H113.775H113.769H113.762H113.756H113.749H113.743H113.736H113.73H113.723H113.716H113.709H113.702H113.695H113.688H113.681H113.673H113.666H113.659H113.651H113.644H113.636H113.629H113.621H113.613H113.605H113.597H113.589H113.581H113.573H113.565H113.557H113.549H113.54H113.532H113.523H113.515H113.506H113.497H113.488H113.479H113.47H113.461H113.452H113.443H113.434H113.424H113.415H113.406H113.396H113.386H113.377H113.367H113.357H113.347H113.337H113.327H113.317H113.306H113.296H113.286H113.275H113.265H113.254H113.243H113.232H113.222H113.211H113.2H113.188H113.177H113.166H113.155H113.143H113.132H113.12H113.108H113.096H113.084H113.073H113.06H113.048H113.036H113.024H113.011H112.999H112.986H112.974H112.961H112.948H112.935H112.922H112.909H112.896H112.883H112.869H112.856H112.843H112.829H112.815H112.801H112.788H112.774H112.759H112.745H112.731H112.717H112.702H112.688H112.673H112.658H112.644H112.629H112.614H112.599H112.583H112.568H112.553H112.537H112.522H112.506H112.49H112.474H112.459H112.442H112.426H112.41H112.394H112.377H112.361H112.344H112.327H112.311H112.294H112.277H112.259H112.242H112.225H112.207H112.19H112.172H112.155H112.137H112.119H112.101H112.082H112.064H112.046H112.027H112.009H111.99H111.971H111.952H111.933H111.914H111.895H111.876H111.856H111.837H111.817H111.798H111.778H111.758H111.738H111.717H111.697H111.677H111.656H111.636H111.615H111.594H111.573H111.552H111.531H111.51H111.488H111.467H111.445H111.423H111.401H111.38H111.357H111.335H111.313H111.291H111.268H111.245H111.223H111.2H111.177H111.154H111.13H111.107H111.084H111.06H111.036H111.012H110.989H110.964H110.94H110.916H110.892H110.867H110.842H110.818H110.793H110.768H110.743H110.717H110.692H110.666H110.641H110.615H110.589H110.563H110.537H110.511H110.484H110.458H110.431H110.405H110.378H110.351H110.324H110.296H110.269H110.241H110.214H110.186H110.158H110.13H110.102H110.074H110.045H110.017H109.988H109.959H109.93H109.901H109.872H109.843H109.813H109.784H109.754H109.724H109.694H109.664H109.634H109.604H109.573H109.542H109.512H109.481H109.45H109.418H109.387H109.356H109.324H109.292H109.261H109.229H109.196H109.164H109.132H109.099H109.066H109.034H109.001H108.968H108.934H108.901H108.867H108.834H108.8H108.766H108.732H108.698H108.663H108.629H108.594H108.559H108.524H108.489H108.454H108.419H108.383H108.348H108.312H108.276H108.24H108.203H108.167H108.13H108.094H108.057H108.02H107.983H107.946H107.908H107.871H107.833H107.795H107.757H107.719H107.68H107.642H107.603H107.565H107.526H107.487H107.447H107.408H107.369H107.329H107.289H107.249H107.209H107.169H107.128H107.088H107.047H107.006H106.965H106.924H106.882H106.841H106.799H106.757H106.715H106.673H106.631H106.588H106.546H106.503H106.46H106.417H106.373H106.33H106.286H106.243H106.199H106.155H106.11H106.066H106.021H105.977H105.932H105.887H105.842H105.796H105.751H105.705H105.659H105.613H105.567H105.521H105.474H105.427H105.381H105.334H105.286H105.239H105.192H105.144H105.096H105.048H105H104.951H104.903H104.854H104.805H104.756H104.707H104.658H104.608H104.559H104.509H104.459H104.408H104.358H104.307H104.257H104.206H104.155H104.103H104.052H104.016H103.98H103.944H103.908H103.872H103.835H103.799H103.763H103.726H103.689H103.653H103.616H103.579H103.542H103.505H103.468H103.43H103.393H103.356H103.318H103.28H103.243H103.205H103.167H103.129H103.091H103.053H103.015H102.977H102.938H102.9H102.861H102.823H102.784H102.745H102.706H102.667H102.628H102.589H102.55H102.51H102.471H102.432H102.392H102.352H102.313H102.273H102.233H102.193H102.153H102.112H102.072H102.032H101.991H101.951H101.91H101.869H101.828H101.788H101.746H101.705H101.664H101.623H101.582H101.54H101.499H101.457H101.415H101.373H101.331H101.289H101.247H101.205H101.163H101.121H101.078H101.036H100.993H100.95H100.907H100.864H100.821H100.778H100.735H100.692H100.649H100.605H100.562H100.518H100.474H100.43H100.386H100.342H100.298H100.254H100.21H100.165H100.121H100.076H100.032H99.9869H99.942H99.8971H99.852H99.8069H99.7616H99.7163H99.6709H99.6254H99.5798H99.5341H99.4883H99.4424H99.3964H99.3503H99.3042H99.2579H99.2115H99.1651H99.1185H99.0718H99.0251H98.9783H98.9313H98.8843H98.8372H98.7899H98.7426H98.6952H98.6477H98.6001H98.5524H98.5046H98.4566H98.4087H98.3606H98.3124H98.2641H98.2157H98.1672H98.1186H98.07H98.0212H97.9723H97.9233H97.8743H97.8251H97.7758H97.7265H97.677H97.6274H97.5778H97.528H97.4782H97.4282H97.3782H97.328H97.2778H97.2274H97.177H97.1264H97.0758H97.025H96.9742H96.9232H96.8722H96.821H96.7698H96.7185H96.667H96.6155H96.5638H96.5121H96.4602H96.4083H96.3562H96.3041H96.2518H96.1995H96.147H96.0945H96.0418H95.9891H95.9362H95.8832H95.8302H95.777H95.7237H95.6704H95.6169H95.5633H95.5097H95.4559H95.402H95.348H95.2939H95.2397H95.1854H95.1311H95.0766H95.022H94.9673H94.9124H94.8575H94.8025H94.7474H94.6922H94.6369H94.5814H94.5259H94.4703H94.4145H94.3587H94.3027H94.2467H94.1905H94.1342H94.0779H94.0214H93.9648H93.9081H93.8513H93.7944H93.7374H93.6803H93.6231H93.5658H93.5084H93.4508H93.3932H93.3355H93.2776H93.2197H93.1616H93.1034H93.0452H92.9868H92.9283H92.8697H92.811H92.7522H92.6933H92.6343H92.5751H92.5159H92.4565H92.3971H92.3375H92.2779H92.2181H92.1582H92.0982H92.0381H91.9779H91.9176H91.8571H91.7966H91.736H91.6752H91.6143H91.5534H91.4923H91.4311H91.3698H91.3084H91.2469H91.1852H91.1235H91.0617H90.9997H90.9376H90.8755H90.8132H90.7508H90.6883H90.6256H90.5629H90.5001H90.4371H90.3741H90.3109H90.2476H90.1842H90.1207H90.0571H89.9934H89.9295H89.8656H89.8015H89.7373H89.673H89.6086H89.5441H89.4795H89.4148H89.3499H89.2849H89.2199H89.1547H89.0894H89.024H88.9584H88.8928H88.827H88.7612H88.6952H88.6291H88.5629H88.4966H88.4301H88.3636H88.2969H88.2302H88.1633H88.0963H88.0291H87.9619H87.8946H87.8271H87.7595H87.6918H87.624H87.5561H87.4881H87.4199H87.3516H87.2832H87.2147H87.1461H87.0774H87.0085H86.9396H86.8705H86.8013H86.732H86.6626H86.593H86.5234H86.4536H86.3837H86.3137H86.2435H86.1733H86.1029H86.0325H85.9619H85.8911H85.8203H85.7494H85.6783H85.6071H85.5358H85.4644H85.3928H85.3212H85.2494H85.1775H85.1055H85.0334H84.9611H84.8887H84.8163H84.7436H84.6709H84.5981H84.5251H84.452H84.3788H84.3055H84.2321H84.1585H84.0848H84.011H83.9371H83.863H83.7889H83.7146H83.6402H83.5657H83.491H83.4163H83.3414H83.2664H83.1912H83.116H83.0406H82.9651H82.8895H82.8138H82.7379H82.6619H82.5858H82.5096H82.4333H82.3568H82.2802H82.2035H82.1267H82.0497H81.9726H81.8954H81.8181H81.7407H81.6631H81.5854H81.5076H81.4296H81.3516H81.2734H81.1951H81.1166H81.0381H80.9594H80.8806H80.8017H80.7226H80.6434H80.5641H80.4847H80.4051H80.3255H80.2457H80.1657H80.0857H80.0055H79.9252H79.8448H79.7642H79.6836H79.6028H79.5218H79.4408H79.3596H79.2783H79.1969H79.1153H79.0336H78.9518H78.8699H78.7878H78.7056H78.6233H78.5409H78.4583H78.3756H78.2928H78.2098H78.1267H78.0435H77.9602H77.8767H77.7931H77.7094H77.6256H77.5416H77.4575H77.3733H77.2889H77.2044H77.1198H77.0351H76.9502H76.8652H76.7801H76.6948H76.6094H76.5239H76.4383H76.3525H76.2666H76.1806H76.0944H76.0081H75.9217H75.8351H75.7484H75.6616H75.5747H75.4876H75.4004H75.3131H75.2256H75.138H75.0503H74.9624H74.8744H74.7863H74.6981H74.6097H74.5212H74.4325H74.3438H74.2549H74.1658H74.0766H73.9873H73.8979H73.8083H73.7186H73.6288H73.5388H73.4487H73.3585H73.2682H73.1777H73.087H72.9963H72.9054H72.8143H72.7232H72.6319H72.5405L65.0846 85.9606Z"
          stroke="black"
          strokeWidth="0.2"
        />
      </g>
      <path
        d="M114.181 86.0607C122.27 86.0607 128.882 79.5194 128.882 71.4308C128.882 63.3421 122.27 56.8008 114.181 56.8008C106.092 56.8008 99.4801 63.3421 99.4801 71.4308C99.4801 79.5194 106.092 86.0607 114.181 86.0607Z"
        fill="url(#paint1_linear_7062_86955)"
      />
      <path
        d="M90.329 86.2014C104.675 86.2014 116.361 74.5255 116.361 60.1065C116.361 45.6876 104.675 34.0117 90.329 34.0117C75.9833 34.0117 64.2969 45.6876 64.2969 60.1065C64.2969 74.5255 75.9133 86.2014 90.329 86.2014Z"
        fill="url(#paint2_linear_7062_86955)"
      />
      <path
        d="M88.3371 55.0236C85.2645 55.0236 82.1422 54.2114 82.1422 52.6699C82.1422 52.2556 82.3747 51.6589 83.4875 51.1451C83.7034 51.0456 83.9359 51.1451 84.0355 51.344C84.1352 51.5594 84.0355 51.7915 83.8362 51.8909C83.1885 52.1893 82.9726 52.4876 82.9726 52.6534C82.9726 53.2832 85.0653 54.1783 88.3371 54.1783C91.6089 54.1783 93.7015 53.2666 93.7015 52.6534C93.7015 52.4379 93.3859 52.0898 92.5223 51.7583C92.3064 51.6755 92.2068 51.4434 92.2898 51.2279C92.3728 51.0125 92.6054 50.913 92.8213 50.9959C94.233 51.5429 94.5319 52.2058 94.5319 52.6699C94.5319 54.2114 91.4096 55.0236 88.3371 55.0236Z"
        fill="#15112D"
      />
      <path
        d="M88.2485 38.275C86.7446 38.275 85.5254 39.4941 85.5254 40.998C85.5254 42.502 86.7446 43.7211 88.2485 43.7211C89.7525 43.7211 90.9716 42.502 90.9716 40.998C90.9716 39.4941 89.7525 38.275 88.2485 38.275ZM87.738 52.3584C87.738 52.6404 87.9665 52.869 88.2485 52.869C88.5305 52.869 88.7591 52.6404 88.7591 52.3584L87.738 52.3584ZM87.738 40.998L87.738 52.3584L88.7591 52.3584L88.7591 40.998L87.738 40.998Z"
        fill="black"
      />
      <path
        d="M95.3093 36.1987C95.3093 40.1209 92.114 43.2975 88.191 43.2975C84.2488 43.2975 81.0727 40.1211 81.0727 36.1987C81.0727 32.2766 84.268 29.1 88.191 29.1C92.114 29.1 95.3093 32.2766 95.3093 36.1987Z"
        fill="url(#paint3_radial_7062_86955)"
        stroke="black"
        strokeWidth="0.2"
      />
      <g filter="url(#filter1_d_7062_86955)">
        <path
          d="M340.882 71.4306C340.882 79.5193 334.34 86.0606 326.181 86.0606C326.04 86.0606 324.844 86.0606 316.052 86.0606C309.933 86.0606 300.156 86.0606 284.54 86.0606H277.085C267.308 86.2716 259.5 78.4642 259.5 69.0392C259.5 59.5437 267.378 51.6661 277.296 52.1584C285.807 25.5712 324.774 29.2991 328.08 56.8006C335.395 57.715 340.882 63.9046 340.882 71.4306Z"
          fill="url(#paint4_linear_7062_86955)"
        />
        <path
          d="M277.085 85.9606L277.082 85.9606C267.361 86.1704 259.6 78.4081 259.6 69.0392C259.6 59.5996 267.431 51.7688 277.291 52.2583L277.367 52.2621L277.391 52.1889C285.869 25.7028 324.688 29.4189 327.981 56.8126L327.99 56.8902L328.068 56.8998C335.332 57.8079 340.782 63.9546 340.782 71.4306C340.782 79.4637 334.285 85.9606 326.181 85.9606H326.18H326.179H326.178H326.177H326.176H326.175H326.174H326.173H326.172H326.171H326.17H326.169H326.168H326.167H326.166H326.164H326.163H326.162H326.16H326.159H326.158H326.156H326.155H326.153H326.152H326.15H326.149H326.147H326.146H326.144H326.142H326.14H326.139H326.137H326.135H326.133H326.131H326.129H326.127H326.125H326.123H326.121H326.119H326.117H326.115H326.113H326.11H326.108H326.106H326.103H326.101H326.098H326.096H326.093H326.091H326.088H326.086H326.083H326.08H326.077H326.075H326.072H326.069H326.066H326.063H326.06H326.057H326.054H326.05H326.047H326.044H326.041H326.037H326.034H326.03H326.027H326.023H326.02H326.016H326.013H326.009H326.005H326.001H325.997H325.994H325.99H325.986H325.982H325.977H325.973H325.969H325.965H325.96H325.956H325.952H325.947H325.943H325.938H325.934H325.929H325.924H325.919H325.915H325.91H325.905H325.9H325.895H325.89H325.884H325.879H325.874H325.869H325.863H325.858H325.852H325.847H325.841H325.835H325.83H325.824H325.818H325.812H325.806H325.8H325.794H325.788H325.782H325.775H325.769H325.762H325.756H325.749H325.743H325.736H325.73H325.723H325.716H325.709H325.702H325.695H325.688H325.681H325.673H325.666H325.659H325.651H325.644H325.636H325.629H325.621H325.613H325.605H325.597H325.589H325.581H325.573H325.565H325.557H325.549H325.54H325.532H325.523H325.515H325.506H325.497H325.488H325.479H325.47H325.461H325.452H325.443H325.434H325.424H325.415H325.406H325.396H325.386H325.377H325.367H325.357H325.347H325.337H325.327H325.317H325.306H325.296H325.286H325.275H325.265H325.254H325.243H325.232H325.222H325.211H325.2H325.188H325.177H325.166H325.155H325.143H325.132H325.12H325.108H325.096H325.084H325.073H325.06H325.048H325.036H325.024H325.011H324.999H324.986H324.974H324.961H324.948H324.935H324.922H324.909H324.896H324.883H324.869H324.856H324.843H324.829H324.815H324.801H324.788H324.774H324.759H324.745H324.731H324.717H324.702H324.688H324.673H324.658H324.644H324.629H324.614H324.599H324.583H324.568H324.553H324.537H324.522H324.506H324.49H324.474H324.459H324.442H324.426H324.41H324.394H324.377H324.361H324.344H324.327H324.311H324.294H324.277H324.259H324.242H324.225H324.207H324.19H324.172H324.155H324.137H324.119H324.101H324.082H324.064H324.046H324.027H324.009H323.99H323.971H323.952H323.933H323.914H323.895H323.876H323.856H323.837H323.817H323.798H323.778H323.758H323.738H323.717H323.697H323.677H323.656H323.636H323.615H323.594H323.573H323.552H323.531H323.51H323.488H323.467H323.445H323.423H323.401H323.38H323.357H323.335H323.313H323.291H323.268H323.245H323.223H323.2H323.177H323.154H323.13H323.107H323.084H323.06H323.036H323.012H322.989H322.964H322.94H322.916H322.892H322.867H322.842H322.818H322.793H322.768H322.743H322.717H322.692H322.666H322.641H322.615H322.589H322.563H322.537H322.511H322.484H322.458H322.431H322.405H322.378H322.351H322.324H322.296H322.269H322.241H322.214H322.186H322.158H322.13H322.102H322.074H322.045H322.017H321.988H321.959H321.93H321.901H321.872H321.843H321.813H321.784H321.754H321.724H321.694H321.664H321.634H321.604H321.573H321.542H321.512H321.481H321.45H321.418H321.387H321.356H321.324H321.292H321.261H321.229H321.196H321.164H321.132H321.099H321.066H321.034H321.001H320.968H320.934H320.901H320.867H320.834H320.8H320.766H320.732H320.698H320.663H320.629H320.594H320.559H320.524H320.489H320.454H320.419H320.383H320.348H320.312H320.276H320.24H320.203H320.167H320.13H320.094H320.057H320.02H319.983H319.946H319.908H319.871H319.833H319.795H319.757H319.719H319.68H319.642H319.603H319.565H319.526H319.487H319.447H319.408H319.369H319.329H319.289H319.249H319.209H319.169H319.128H319.088H319.047H319.006H318.965H318.924H318.882H318.841H318.799H318.757H318.715H318.673H318.631H318.588H318.546H318.503H318.46H318.417H318.373H318.33H318.286H318.243H318.199H318.155H318.11H318.066H318.021H317.977H317.932H317.887H317.842H317.796H317.751H317.705H317.659H317.613H317.567H317.521H317.474H317.427H317.381H317.334H317.286H317.239H317.192H317.144H317.096H317.048H317H316.951H316.903H316.854H316.805H316.756H316.707H316.658H316.608H316.559H316.509H316.459H316.408H316.358H316.307H316.257H316.206H316.155H316.103H316.052H316.016H315.98H315.944H315.908H315.872H315.835H315.799H315.763H315.726H315.689H315.653H315.616H315.579H315.542H315.505H315.468H315.43H315.393H315.356H315.318H315.28H315.243H315.205H315.167H315.129H315.091H315.053H315.015H314.977H314.938H314.9H314.861H314.823H314.784H314.745H314.706H314.667H314.628H314.589H314.55H314.51H314.471H314.432H314.392H314.352H314.313H314.273H314.233H314.193H314.153H314.112H314.072H314.032H313.991H313.951H313.91H313.869H313.828H313.788H313.746H313.705H313.664H313.623H313.582H313.54H313.499H313.457H313.415H313.373H313.331H313.289H313.247H313.205H313.163H313.121H313.078H313.036H312.993H312.95H312.907H312.864H312.821H312.778H312.735H312.692H312.649H312.605H312.562H312.518H312.474H312.43H312.386H312.342H312.298H312.254H312.21H312.165H312.121H312.076H312.032H311.987H311.942H311.897H311.852H311.807H311.762H311.716H311.671H311.625H311.58H311.534H311.488H311.442H311.396H311.35H311.304H311.258H311.212H311.165H311.118H311.072H311.025H310.978H310.931H310.884H310.837H310.79H310.743H310.695H310.648H310.6H310.552H310.505H310.457H310.409H310.361H310.312H310.264H310.216H310.167H310.119H310.07H310.021H309.972H309.923H309.874H309.825H309.776H309.726H309.677H309.627H309.578H309.528H309.478H309.428H309.378H309.328H309.278H309.227H309.177H309.126H309.076H309.025H308.974H308.923H308.872H308.821H308.77H308.718H308.667H308.615H308.564H308.512H308.46H308.408H308.356H308.304H308.252H308.199H308.147H308.094H308.042H307.989H307.936H307.883H307.83H307.777H307.724H307.67H307.617H307.563H307.51H307.456H307.402H307.348H307.294H307.24H307.185H307.131H307.077H307.022H306.967H306.912H306.858H306.803H306.747H306.692H306.637H306.581H306.526H306.47H306.415H306.359H306.303H306.247H306.19H306.134H306.078H306.021H305.965H305.908H305.851H305.794H305.737H305.68H305.623H305.566H305.508H305.451H305.393H305.335H305.278H305.22H305.162H305.103H305.045H304.987H304.928H304.87H304.811H304.752H304.693H304.634H304.575H304.516H304.457H304.397H304.338H304.278H304.218H304.158H304.098H304.038H303.978H303.918H303.857H303.797H303.736H303.675H303.614H303.553H303.492H303.431H303.37H303.308H303.247H303.185H303.124H303.062H303H302.938H302.875H302.813H302.751H302.688H302.626H302.563H302.5H302.437H302.374H302.311H302.248H302.184H302.121H302.057H301.993H301.93H301.866H301.801H301.737H301.673H301.609H301.544H301.479H301.415H301.35H301.285H301.22H301.155H301.089H301.024H300.958H300.893H300.827H300.761H300.695H300.629H300.563H300.497H300.43H300.364H300.297H300.23H300.163H300.096H300.029H299.962H299.895H299.827H299.76H299.692H299.624H299.556H299.488H299.42H299.352H299.283H299.215H299.146H299.077H299.009H298.94H298.871H298.801H298.732H298.663H298.593H298.523H298.454H298.384H298.314H298.244H298.173H298.103H298.032H297.962H297.891H297.82H297.749H297.678H297.607H297.536H297.464H297.393H297.321H297.249H297.178H297.105H297.033H296.961H296.889H296.816H296.744H296.671H296.598H296.525H296.452H296.379H296.306H296.232H296.158H296.085H296.011H295.937H295.863H295.789H295.715H295.64H295.566H295.491H295.416H295.341H295.266H295.191H295.116H295.041H294.965H294.889H294.814H294.738H294.662H294.586H294.51H294.433H294.357H294.28H294.203H294.127H294.05H293.973H293.895H293.818H293.741H293.663H293.585H293.508H293.43H293.352H293.273H293.195H293.117H293.038H292.959H292.881H292.802H292.723H292.643H292.564H292.485H292.405H292.325H292.246H292.166H292.086H292.006H291.925H291.845H291.764H291.684H291.603H291.522H291.441H291.36H291.278H291.197H291.115H291.034H290.952H290.87H290.788H290.706H290.623H290.541H290.458H290.376H290.293H290.21H290.127H290.044H289.96H289.877H289.793H289.709H289.626H289.542H289.458H289.373H289.289H289.204H289.12H289.035H288.95H288.865H288.78H288.695H288.609H288.524H288.438H288.352H288.267H288.181H288.094H288.008H287.922H287.835H287.748H287.662H287.575H287.488H287.4H287.313H287.226H287.138H287.05H286.962H286.874H286.786H286.698H286.61H286.521H286.433H286.344H286.255H286.166H286.077H285.987H285.898H285.808H285.719H285.629H285.539H285.449H285.359H285.268H285.178H285.087H284.996H284.905H284.814H284.723H284.632H284.54L277.085 85.9606Z"
          stroke="black"
          strokeWidth="0.2"
        />
      </g>
      <path
        d="M326.181 86.0607C334.27 86.0607 340.882 79.5194 340.882 71.4308C340.882 63.3421 334.27 56.8008 326.181 56.8008C318.092 56.8008 311.48 63.3421 311.48 71.4308C311.48 79.5194 318.092 86.0607 326.181 86.0607Z"
        fill="url(#paint5_linear_7062_86955)"
      />
      <path
        d="M302.329 86.2014C316.675 86.2014 328.361 74.5255 328.361 60.1065C328.361 45.6876 316.675 34.0117 302.329 34.0117C287.983 34.0117 276.297 45.6876 276.297 60.1065C276.297 74.5255 287.913 86.2014 302.329 86.2014Z"
        fill="url(#paint6_linear_7062_86955)"
      />
      <path
        d="M300.337 55.0236C297.265 55.0236 294.142 54.2114 294.142 52.6699C294.142 52.2556 294.375 51.6589 295.487 51.1451C295.703 51.0456 295.936 51.1451 296.036 51.344C296.135 51.5594 296.036 51.7915 295.836 51.8909C295.189 52.1893 294.973 52.4876 294.973 52.6534C294.973 53.2832 297.065 54.1783 300.337 54.1783C303.609 54.1783 305.702 53.2666 305.702 52.6534C305.702 52.4379 305.386 52.0898 304.522 51.7583C304.306 51.6755 304.207 51.4434 304.29 51.2279C304.373 51.0125 304.605 50.913 304.821 50.9959C306.233 51.5429 306.532 52.2058 306.532 52.6699C306.532 54.2114 303.41 55.0236 300.337 55.0236Z"
        fill="#15112D"
      />
      <path
        d="M300.249 38.275C298.745 38.275 297.525 39.4941 297.525 40.998C297.525 42.502 298.745 43.7211 300.249 43.7211C301.752 43.7211 302.972 42.502 302.972 40.998C302.972 39.4941 301.752 38.275 300.249 38.275ZM299.738 52.3584C299.738 52.6404 299.967 52.869 300.249 52.869C300.531 52.869 300.759 52.6404 300.759 52.3584L299.738 52.3584ZM299.738 40.998L299.738 52.3584L300.759 52.3584L300.759 40.998L299.738 40.998Z"
        fill="black"
      />
      <path
        d="M307.309 36.1987C307.309 40.1209 304.114 43.2975 300.191 43.2975C296.249 43.2975 293.073 40.1211 293.073 36.1987C293.073 32.2766 296.268 29.1 300.191 29.1C304.114 29.1 307.309 32.2766 307.309 36.1987Z"
        fill="url(#paint7_radial_7062_86955)"
        stroke="black"
        strokeWidth="0.2"
      />
      <g filter="url(#filter2_dddd_7062_86955)">
        <path
          d="M238.339 315.342C220.804 315.85 199.966 315.342 184.973 315.088C170.233 315.596 149.141 315.85 131.606 315.342C148.887 305.431 154.986 287.134 155.748 274.936H213.689C215.214 286.879 221.313 305.431 238.339 315.342Z"
          fill="url(#paint8_linear_7062_86955)"
        />
      </g>
      <g filter="url(#filter3_d_7062_86955)">
        <path
          d="M294.5 121.189V272.903C294.5 276.715 291.45 279.51 288.147 279.51H83.0668C79.509 279.51 76.7136 276.461 76.7136 272.903V121.189C76.7136 117.632 79.7631 114.582 83.0668 114.582H287.893C291.705 114.582 294.5 117.632 294.5 121.189Z"
          fill="white"
        />
        <path
          d="M294.386 121.189V272.903C294.386 276.652 291.388 279.396 288.147 279.396H83.0668C79.5777 279.396 76.8276 276.404 76.8276 272.903V121.189C76.8276 117.692 79.8289 114.696 83.0668 114.696H287.893C291.639 114.696 294.386 117.692 294.386 121.189Z"
          stroke="black"
          strokeWidth="0.22797"
        />
      </g>
      <path
        d="M294.5 121.189V251.81H76.7136V121.189C76.7136 117.632 79.7631 114.582 83.0668 114.582H287.893C291.705 114.582 294.5 117.632 294.5 121.189Z"
        fill="#C5C5C5"
      />
      <path
        d="M286.115 122.969H84.0842V244.441H286.369V122.969H286.115Z"
        fill="white"
      />
      <path
        d="M185.227 270.459C188.276 270.459 190.563 268.172 190.563 265.123C190.563 262.073 188.276 259.786 185.227 259.786C182.177 259.786 179.89 262.073 179.89 265.123C179.89 268.172 182.177 270.459 185.227 270.459Z"
        fill="#D0D8E6"
      />
      <path
        opacity="0.5"
        d="M270.104 174.628H270.12L270.135 174.627C272.467 174.394 274.119 176.251 274.119 178.388V193.89C274.119 196.008 272.477 197.65 270.359 197.65H99.5856C97.4675 197.65 95.8257 196.008 95.8257 193.89V178.388C95.8257 176.27 97.4675 174.628 99.5856 174.628H270.104Z"
        fill="white"
        stroke="black"
        strokeWidth="0.612172"
      />
      <path
        d="M105.883 191.26C105.437 191.26 104.991 191.037 104.768 190.814L101.424 187.47C100.755 186.801 100.755 185.91 101.424 185.241C102.093 184.572 102.985 184.572 103.654 185.241L105.66 187.247L110.565 182.342C111.234 181.674 112.126 181.674 112.794 182.342C113.463 183.011 113.463 183.903 112.794 184.572L106.775 190.592C106.552 191.037 106.106 191.26 105.883 191.26Z"
        fill="#47BE79"
      />
      <path
        opacity="0.5"
        d="M270.104 141.57H270.119L270.135 141.568C272.466 141.335 274.118 143.193 274.118 145.33V160.831C274.118 162.95 272.476 164.591 270.358 164.591H99.5854C97.4673 164.591 95.8254 162.95 95.8254 160.831V145.33C95.8254 143.212 97.4673 141.57 99.5854 141.57H270.104Z"
        fill="white"
        stroke="black"
        strokeWidth="0.612172"
      />
      <path
        d="M105.883 158.26C105.437 158.26 104.991 158.037 104.768 157.814L101.424 154.47C100.755 153.801 100.755 152.91 101.424 152.241C102.093 151.572 102.985 151.572 103.654 152.241L105.66 154.247L110.565 149.342C111.234 148.674 112.126 148.674 112.794 149.342C113.463 150.011 113.463 150.903 112.794 151.572L106.775 157.592C106.552 158.037 106.106 158.26 105.883 158.26Z"
        fill="#47BE79"
      />
      <path
        opacity="0.5"
        d="M270.104 206.737H270.119L270.135 206.736C271.324 206.617 272.313 206.974 273.005 207.637C273.7 208.302 274.118 209.299 274.118 210.497V225.999C274.118 228.117 272.476 229.759 270.358 229.759H99.5854C97.4673 229.759 95.8254 228.117 95.8254 225.999V210.497C95.8254 208.379 97.4673 206.737 99.5854 206.737H270.104Z"
        fill="white"
        stroke="black"
        strokeWidth="0.612172"
      />
      <path
        d="M92.4697 132.37C93.7403 132.37 94.7568 131.354 94.7568 130.083C94.7568 128.812 93.7403 127.796 92.4697 127.796C91.1991 127.796 90.1826 128.812 90.1826 130.083C90.1826 131.354 91.1991 132.37 92.4697 132.37Z"
        fill="#FD561F"
      />
      <path
        d="M99.8397 132.37C101.11 132.37 102.127 131.354 102.127 130.083C102.127 128.812 101.11 127.796 99.8397 127.796C98.5691 127.796 97.5526 128.812 97.5526 130.083C97.5526 131.354 98.5691 132.37 99.8397 132.37Z"
        fill="#F7AD3C"
      />
      <path
        d="M107.21 132.37C108.48 132.37 109.497 131.354 109.497 130.083C109.497 128.812 108.48 127.796 107.21 127.796C105.939 127.796 104.923 128.812 104.923 130.083C104.923 131.354 105.939 132.37 107.21 132.37Z"
        fill="#19AE57"
      />
      <path
        d="M264.384 162.251L264.384 162.251C262.234 164.128 259.409 165.258 256.328 165.258C253.248 165.258 250.424 164.128 248.273 162.233L248.273 162.233C245.703 159.991 244.081 156.693 244.081 153.011C244.081 146.25 249.567 140.764 256.328 140.764C263.09 140.764 268.576 146.268 268.576 153.029C268.576 156.711 266.954 160.01 264.384 162.251Z"
        fill="#C8B5F8"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M266.221 145.329C266.702 145.329 267.093 144.939 267.093 144.457C267.093 143.975 266.702 143.585 266.221 143.585C265.74 143.585 265.35 143.975 265.35 144.457C265.35 144.939 265.74 145.329 266.221 145.329Z"
        fill="#EAEEF9"
      />
      <path
        d="M243.073 150.046C243.39 150.046 243.647 149.789 243.647 149.472C243.647 149.155 243.39 148.898 243.073 148.898C242.757 148.898 242.5 149.155 242.5 149.472C242.5 149.789 242.757 150.046 243.073 150.046Z"
        fill="#EAEEF9"
      />
      <path
        d="M245.709 160.362C246.025 160.362 246.282 160.106 246.282 159.789C246.282 159.472 246.025 159.215 245.709 159.215C245.392 159.215 245.135 159.472 245.135 159.789C245.135 160.106 245.392 160.362 245.709 160.362Z"
        fill="#EAEEF9"
      />
      <path
        d="M248.773 160.362L256.818 157.841V147.506L248.773 150.007V160.362Z"
        fill="#B7BFCD"
      />
      <path
        opacity="0.4"
        d="M264.863 160.362L256.818 157.841V147.506L264.863 150.007V160.362Z"
        fill="#6D7C9A"
      />
      <path
        d="M248.773 160.362L256.818 157.841V147.506L248.773 150.007V160.362Z"
        fill="url(#paint9_linear_7062_86955)"
      />
      <path
        d="M264.863 160.362L256.818 157.841V147.506L264.863 150.007V160.362Z"
        fill="url(#paint10_linear_7062_86955)"
      />
      <path
        d="M256.754 152.614V162.814L248.838 160.334V150.134L256.754 152.614Z"
        fill="#EDF1F9"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M264.799 160.334L256.883 162.814V152.614L264.799 150.134V160.334Z"
        fill="#DAE1ED"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        opacity="0.09"
        d="M254.996 161.08L248.773 160.381V150.046L256.818 152.567L254.996 161.08Z"
        fill="url(#paint11_linear_7062_86955)"
      />
      <path
        opacity="0.2"
        d="M258.641 159.257L264.863 160.381V150.046L256.818 152.567L258.641 159.257Z"
        fill="url(#paint12_linear_7062_86955)"
      />
      <path
        d="M245.003 147.447L253.024 144.747L256.678 147.482L248.783 149.937L245.003 147.447Z"
        fill="#DAE1ED"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M264.853 149.937L256.959 147.482L260.612 144.747L268.634 147.447L264.853 149.937Z"
        fill="#DAE1ED"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M245.007 152.471L248.782 150.116L256.666 152.587L252.797 155.055L245.007 152.471Z"
        fill="#EFF4FD"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M268.629 152.471L260.84 155.055L256.97 152.587L264.854 150.116L268.629 152.471Z"
        fill="#EDF1F9"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M246.282 143.733H245.783V143.234H245.355V143.733H244.856V144.175H245.355V144.674H245.783V144.175H246.282V143.733Z"
        fill="url(#paint13_linear_7062_86955)"
      />
      <path
        d="M247.378 156.254H246.879V155.755H246.451V156.254H245.952V156.696H246.451V157.195H246.879V156.696H247.378V156.254Z"
        fill="url(#paint14_linear_7062_86955)"
      />
      <path
        d="M269.192 156.281L268.581 155.973L268.889 155.362L268.366 155.098L268.058 155.709L267.447 155.401L267.174 155.941L267.785 156.25L267.477 156.86L268 157.124L268.308 156.514L268.919 156.822L269.192 156.281Z"
        fill="url(#paint15_linear_7062_86955)"
      />
      <path
        d="M264.384 195.251L264.384 195.251C262.234 197.128 259.409 198.258 256.328 198.258C253.248 198.258 250.424 197.128 248.273 195.233L248.273 195.233C245.703 192.991 244.081 189.693 244.081 186.011C244.081 179.25 249.567 173.764 256.328 173.764C263.09 173.764 268.576 179.268 268.576 186.029C268.576 189.711 266.954 193.01 264.384 195.251Z"
        fill="#FCDEB1"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M266.221 178.329C266.702 178.329 267.093 177.939 267.093 177.457C267.093 176.975 266.702 176.585 266.221 176.585C265.74 176.585 265.35 176.975 265.35 177.457C265.35 177.939 265.74 178.329 266.221 178.329Z"
        fill="#EAEEF9"
      />
      <path
        d="M243.073 183.046C243.39 183.046 243.647 182.789 243.647 182.472C243.647 182.155 243.39 181.898 243.073 181.898C242.757 181.898 242.5 182.155 242.5 182.472C242.5 182.789 242.757 183.046 243.073 183.046Z"
        fill="#EAEEF9"
      />
      <path
        d="M245.709 193.362C246.025 193.362 246.282 193.106 246.282 192.789C246.282 192.472 246.025 192.215 245.709 192.215C245.392 192.215 245.135 192.472 245.135 192.789C245.135 193.106 245.392 193.362 245.709 193.362Z"
        fill="#EAEEF9"
      />
      <path
        d="M248.773 193.362L256.818 190.841V180.506L248.773 183.007V193.362Z"
        fill="#B7BFCD"
      />
      <path
        opacity="0.4"
        d="M264.863 193.362L256.818 190.841V180.506L264.863 183.007V193.362Z"
        fill="#6D7C9A"
      />
      <path
        d="M248.773 193.362L256.818 190.841V180.506L248.773 183.007V193.362Z"
        fill="url(#paint16_linear_7062_86955)"
      />
      <path
        d="M264.863 193.362L256.818 190.841V180.506L264.863 183.007V193.362Z"
        fill="url(#paint17_linear_7062_86955)"
      />
      <path
        d="M256.754 185.614V195.814L248.838 193.334V183.134L256.754 185.614Z"
        fill="#EDF1F9"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M264.799 193.334L256.883 195.814V185.614L264.799 183.134V193.334Z"
        fill="#DAE1ED"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        opacity="0.09"
        d="M254.996 194.08L248.773 193.381V183.046L256.818 185.567L254.996 194.08Z"
        fill="url(#paint18_linear_7062_86955)"
      />
      <path
        opacity="0.2"
        d="M258.641 192.257L264.863 193.381V183.046L256.818 185.567L258.641 192.257Z"
        fill="url(#paint19_linear_7062_86955)"
      />
      <path
        d="M245.003 180.447L253.024 177.747L256.678 180.482L248.783 182.937L245.003 180.447Z"
        fill="#DAE1ED"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M264.853 182.937L256.959 180.482L260.612 177.747L268.634 180.447L264.853 182.937Z"
        fill="#DAE1ED"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M245.007 185.471L248.782 183.116L256.666 185.587L252.797 188.055L245.007 185.471Z"
        fill="#EFF4FD"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M268.629 185.471L260.84 188.055L256.97 185.587L264.854 183.116L268.629 185.471Z"
        fill="#EDF1F9"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M246.282 176.733H245.783V176.234H245.355V176.733H244.856V177.175H245.355V177.674H245.783V177.175H246.282V176.733Z"
        fill="url(#paint20_linear_7062_86955)"
      />
      <path
        d="M247.378 189.254H246.879V188.755H246.451V189.254H245.952V189.696H246.451V190.195H246.879V189.696H247.378V189.254Z"
        fill="url(#paint21_linear_7062_86955)"
      />
      <path
        d="M269.192 189.281L268.581 188.973L268.889 188.362L268.366 188.098L268.058 188.709L267.447 188.401L267.174 188.941L267.785 189.25L267.477 189.86L268 190.124L268.308 189.514L268.919 189.822L269.192 189.281Z"
        fill="url(#paint22_linear_7062_86955)"
      />
      <path
        d="M264.384 227.672L264.384 227.672C262.234 229.549 259.409 230.679 256.328 230.679C253.248 230.679 250.424 229.549 248.273 227.654L248.273 227.654C245.703 225.412 244.081 222.113 244.081 218.432C244.081 211.671 249.567 206.185 256.328 206.185C263.09 206.185 268.576 211.689 268.576 218.45C268.576 222.132 266.954 225.43 264.384 227.672Z"
        fill="#A3DFBC"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M266.221 210.75C266.702 210.75 267.093 210.36 267.093 209.878C267.093 209.396 266.702 209.006 266.221 209.006C265.74 209.006 265.35 209.396 265.35 209.878C265.35 210.36 265.74 210.75 266.221 210.75Z"
        fill="#EAEEF9"
      />
      <path
        d="M243.073 215.467C243.39 215.467 243.647 215.21 243.647 214.893C243.647 214.576 243.39 214.319 243.073 214.319C242.757 214.319 242.5 214.576 242.5 214.893C242.5 215.21 242.757 215.467 243.073 215.467Z"
        fill="#EAEEF9"
      />
      <path
        d="M245.709 225.783C246.025 225.783 246.282 225.526 246.282 225.21C246.282 224.893 246.025 224.636 245.709 224.636C245.392 224.636 245.135 224.893 245.135 225.21C245.135 225.526 245.392 225.783 245.709 225.783Z"
        fill="#EAEEF9"
      />
      <path
        d="M248.773 225.783L256.818 223.262V212.927L248.773 215.428V225.783Z"
        fill="#B7BFCD"
      />
      <path
        opacity="0.4"
        d="M264.863 225.783L256.818 223.262V212.927L264.863 215.428V225.783Z"
        fill="#6D7C9A"
      />
      <path
        d="M248.773 225.783L256.818 223.262V212.927L248.773 215.428V225.783Z"
        fill="url(#paint23_linear_7062_86955)"
      />
      <path
        d="M264.863 225.783L256.818 223.262V212.927L264.863 215.428V225.783Z"
        fill="url(#paint24_linear_7062_86955)"
      />
      <path
        d="M256.754 218.035V228.235L248.838 225.755V215.555L256.754 218.035Z"
        fill="#EDF1F9"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M264.799 225.755L256.883 228.235V218.035L264.799 215.555V225.755Z"
        fill="#DAE1ED"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        opacity="0.09"
        d="M254.996 226.5L248.773 225.802V215.467L256.818 217.988L254.996 226.5Z"
        fill="url(#paint25_linear_7062_86955)"
      />
      <path
        opacity="0.2"
        d="M258.641 224.678L264.863 225.802V215.467L256.818 217.988L258.641 224.678Z"
        fill="url(#paint26_linear_7062_86955)"
      />
      <path
        d="M245.003 212.868L253.024 210.168L256.678 212.903L248.783 215.357L245.003 212.868Z"
        fill="#DAE1ED"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M264.853 215.357L256.959 212.903L260.612 210.168L268.634 212.868L264.853 215.357Z"
        fill="#DAE1ED"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M245.007 217.892L248.782 215.537L256.666 218.008L252.797 220.476L245.007 217.892Z"
        fill="#EFF4FD"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M268.629 217.892L260.84 220.476L256.97 218.008L264.854 215.537L268.629 217.892Z"
        fill="#EDF1F9"
        stroke="black"
        strokeWidth="0.129343"
      />
      <path
        d="M246.282 209.154H245.783V208.655H245.355V209.154H244.856V209.596H245.355V210.095H245.783V209.596H246.282V209.154Z"
        fill="url(#paint27_linear_7062_86955)"
      />
      <path
        d="M247.378 221.675H246.879V221.176H246.451V221.675H245.952V222.117H246.451V222.616H246.879V222.117H247.378V221.675Z"
        fill="url(#paint28_linear_7062_86955)"
      />
      <path
        d="M269.192 221.702L268.581 221.394L268.889 220.783L268.366 220.519L268.058 221.13L267.447 220.821L267.174 221.362L267.785 221.67L267.477 222.281L268 222.545L268.308 221.935L268.919 222.243L269.192 221.702Z"
        fill="url(#paint29_linear_7062_86955)"
      />
      <path
        d="M85 89.5C110 119 178.5 188.5 261 99"
        stroke="black"
        strokeDasharray="8 8"
      />
      <path d="M85 89.5C112.5 122.5 142 139.5 167 142.5" stroke="black" />
      <mask id="path-89-inside-1_7062_86955" fill="white">
        <path d="M251.471 110.727L247.98 113.699C247.329 114.213 246.451 113.882 246.224 113.038L244.812 104.82" />
      </mask>
      <path
        d="M251.471 110.727L247.98 113.699C247.329 114.213 246.451 113.882 246.224 113.038L244.812 104.82"
        fill="#47BE79"
      />
      <path
        d="M247.98 113.699L248.104 113.856L248.11 113.851L247.98 113.699ZM246.224 113.038L246.027 113.072L246.029 113.081L246.031 113.09L246.224 113.038ZM251.341 110.575L247.851 113.546L248.11 113.851L251.6 110.88L251.341 110.575ZM247.857 113.542C247.585 113.756 247.276 113.789 247.013 113.69C246.749 113.591 246.515 113.351 246.417 112.986L246.031 113.09C246.16 113.57 246.478 113.917 246.872 114.065C247.268 114.214 247.724 114.155 248.104 113.856L247.857 113.542ZM246.421 113.004L245.009 104.786L244.615 104.854L246.027 113.072L246.421 113.004Z"
        fill="black"
        mask="url(#path-89-inside-1_7062_86955)"
      />
      <path
        d="M284.683 89.1339L282.699 91.0708L282.699 91.0711L259.311 114.078L259.31 114.079C258.285 115.116 256.653 115.121 255.536 114.216L246.706 106.517L246.706 106.516L244.935 104.956L244.934 104.955L240.049 100.611C240.049 100.611 240.049 100.61 240.048 100.61C239.053 99.6944 239.462 97.9933 240.766 97.7496L240.767 97.7495L280.02 90.1724L280.02 90.1724L280.023 90.1718L284.683 89.1339Z"
        fill="#D1EFDD"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M280.108 90.0366L284.693 89.1238L282.712 91.0577L246.733 106.342L245.031 104.952L280.108 90.0366Z"
        fill="#47BE79"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M131.249 151.601H169.917"
        stroke="#696677"
        strokeWidth="1.07413"
        strokeLinecap="round"
      />
      <path
        d="M131.249 185.065H169.917"
        stroke="#696677"
        strokeWidth="1.07413"
        strokeLinecap="round"
      />
      <path
        d="M131.249 216.992H170.991"
        stroke="#696677"
        strokeWidth="1.07413"
        strokeLinecap="round"
      />
      <path
        d="M131.249 155.897H183.881"
        stroke="#696677"
        strokeWidth="1.07413"
        strokeLinecap="round"
      />
      <path
        d="M131.249 189.361H183.881"
        stroke="#696677"
        strokeWidth="1.07413"
        strokeLinecap="round"
      />
      <path
        d="M131.249 220.215H165.621"
        stroke="#696677"
        strokeWidth="1.07413"
        strokeLinecap="round"
      />
      <g clipPath="url(#clip0_7062_86955)">
        <path
          d="M106.981 221.222V223.716M109.475 219.975L111.345 221.845L109.475 219.975ZM110.722 217.481H113.215H110.722ZM104.487 214.988L102.617 213.117L104.487 214.988ZM109.475 214.988L111.345 213.117L109.475 214.988ZM104.487 219.975L102.617 221.845L104.487 219.975ZM100.747 217.481H103.241H100.747ZM106.981 211.247V213.741V211.247Z"
          stroke="#F7AD3C"
          strokeWidth="1.24685"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_7062_86955"
          x="37.3206"
          y="28.9855"
          width="101.74"
          height="72.3482"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="5.08972" />
          <feGaussianBlur stdDeviation="5.08972" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7062_86955"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7062_86955"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_7062_86955"
          x="249.321"
          y="28.9855"
          width="101.74"
          height="72.3482"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="5.08972" />
          <feGaussianBlur stdDeviation="5.08972" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7062_86955"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7062_86955"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_dddd_7062_86955"
          x="127.047"
          y="274.936"
          width="115.852"
          height="56.6415"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.13985" />
          <feGaussianBlur stdDeviation="0.569924" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7062_86955"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.41954" />
          <feGaussianBlur stdDeviation="1.70977" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_7062_86955"
            result="effect2_dropShadow_7062_86955"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6.83909" />
          <feGaussianBlur stdDeviation="1.70977" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_7062_86955"
            result="effect3_dropShadow_7062_86955"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="11.3985" />
          <feGaussianBlur stdDeviation="2.2797" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_7062_86955"
            result="effect4_dropShadow_7062_86955"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect4_dropShadow_7062_86955"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_7062_86955"
          x="35.837"
          y="94.1437"
          width="299.54"
          height="246.681"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="20.4383" />
          <feGaussianBlur stdDeviation="20.4383" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7062_86955"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7062_86955"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_7062_86955"
          x1="88.1908"
          y1="55.5593"
          x2="88.1642"
          y2="86.6252"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.9964" stopColor="#ECF0F5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7062_86955"
          x1="97.9157"
          y1="53.651"
          x2="110.947"
          y2="67.9041"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCCBE1" />
          <stop offset="0.9942" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_7062_86955"
          x1="61.8592"
          y1="48.1323"
          x2="82.3215"
          y2="56.0991"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E2E8F0" />
          <stop offset="0.9942" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_7062_86955"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(89.5249 33.3399) rotate(123.69) scale(10.5853 10.5831)"
        >
          <stop stopColor="#FFDDD2" />
          <stop offset="0.741272" stopColor="#FD784C" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_7062_86955"
          x1="300.191"
          y1="55.5593"
          x2="300.164"
          y2="86.6252"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.9964" stopColor="#ECF0F5" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_7062_86955"
          x1="309.916"
          y1="53.651"
          x2="322.947"
          y2="67.9041"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCCBE1" />
          <stop offset="0.9942" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_7062_86955"
          x1="273.859"
          y1="48.1323"
          x2="294.321"
          y2="56.0991"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E2E8F0" />
          <stop offset="0.9942" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint7_radial_7062_86955"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(301.525 33.3399) rotate(123.69) scale(10.5853 10.5831)"
        >
          <stop stopColor="#FFDDD2" />
          <stop offset="0.741272" stopColor="#FD784C" />
        </radialGradient>
        <linearGradient
          id="paint8_linear_7062_86955"
          x1="184.993"
          y1="314.214"
          x2="184.993"
          y2="278.027"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8ECF5" />
          <stop offset="0.9913" stopColor="#BDC4D7" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_7062_86955"
          x1="254.279"
          y1="148.254"
          x2="253.181"
          y2="152.823"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#606673" />
          <stop offset="1" stopColor="#373C47" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_7062_86955"
          x1="254.279"
          y1="148.254"
          x2="253.181"
          y2="152.823"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#606673" />
          <stop offset="1" stopColor="#373C47" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_7062_86955"
          x1="250.577"
          y1="157.12"
          x2="252.51"
          y2="151.661"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#6C80AA" stopOpacity="0" />
          <stop offset="1" stopColor="#5D6A86" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_7062_86955"
          x1="261.16"
          y1="158.611"
          x2="261.312"
          y2="151.683"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#314F91" stopOpacity="0" />
          <stop offset="1" stopColor="#324264" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_7062_86955"
          x1="245.569"
          y1="143.284"
          x2="245.569"
          y2="144.093"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_7062_86955"
          x1="246.665"
          y1="155.805"
          x2="246.665"
          y2="156.613"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_7062_86955"
          x1="268.597"
          y1="155.292"
          x2="268.098"
          y2="156.281"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_7062_86955"
          x1="254.279"
          y1="181.254"
          x2="253.181"
          y2="185.823"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#606673" />
          <stop offset="1" stopColor="#373C47" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_7062_86955"
          x1="254.279"
          y1="181.254"
          x2="253.181"
          y2="185.823"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#606673" />
          <stop offset="1" stopColor="#373C47" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_7062_86955"
          x1="250.577"
          y1="190.12"
          x2="252.51"
          y2="184.661"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#6C80AA" stopOpacity="0" />
          <stop offset="1" stopColor="#5D6A86" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_7062_86955"
          x1="261.16"
          y1="191.611"
          x2="261.312"
          y2="184.683"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#314F91" stopOpacity="0" />
          <stop offset="1" stopColor="#324264" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_7062_86955"
          x1="245.569"
          y1="176.284"
          x2="245.569"
          y2="177.093"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_7062_86955"
          x1="246.665"
          y1="188.805"
          x2="246.665"
          y2="189.613"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_7062_86955"
          x1="268.597"
          y1="188.292"
          x2="268.098"
          y2="189.281"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_7062_86955"
          x1="254.279"
          y1="213.675"
          x2="253.181"
          y2="218.244"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#606673" />
          <stop offset="1" stopColor="#373C47" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_7062_86955"
          x1="254.279"
          y1="213.675"
          x2="253.181"
          y2="218.244"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#606673" />
          <stop offset="1" stopColor="#373C47" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_7062_86955"
          x1="250.577"
          y1="222.54"
          x2="252.51"
          y2="217.082"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#6C80AA" stopOpacity="0" />
          <stop offset="1" stopColor="#5D6A86" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_7062_86955"
          x1="261.16"
          y1="224.032"
          x2="261.312"
          y2="217.104"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#314F91" stopOpacity="0" />
          <stop offset="1" stopColor="#324264" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_7062_86955"
          x1="245.569"
          y1="208.705"
          x2="245.569"
          y2="209.514"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_7062_86955"
          x1="246.665"
          y1="221.226"
          x2="246.665"
          y2="222.034"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_7062_86955"
          x1="268.597"
          y1="220.713"
          x2="268.098"
          y2="221.701"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <clipPath id="clip0_7062_86955">
          <rect
            width="14.9622"
            height="14.9622"
            fill="white"
            transform="translate(99.5 210)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
